import app from './config/configApp';
import router from './routes/protectedRoute';
import store from '@/vuex/store';
import './static/css/style.css';
import {abilitiesPlugin} from "@casl/vue";
import ability from "./core/plugins/acl/ability";
import '@/core/plugins/ant-design';
import '@/core/plugins/fonts';
import '@/core/plugins/maps';
import '@/core/plugins/masonry';
import '@/core/plugins/apexcharts';
import '@/core/components/custom';
import '@/core/components/style';
app.config.productionTip = false;
app.use(store);
app.use(router);
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true
});
app.mount('#app');
